import { Component, ContentChild, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SliderActionsDirective } from 'src/app/directives/slider-actions.directive';
import { SliderSubheaderDirective } from 'src/app/directives/slider-subheader.directive';
import { SliderTitleDirective } from 'src/app/directives/slider-title.directive';
import { RecordSwipperItem, RecordSwipperUtils, SwiperConfigType } from 'src/app/models/record-swiper';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-record-slider',
  templateUrl: './record-slider.component.html',
  styleUrls: ['./record-slider.component.scss'],
})
export class RecordSliderComponent implements OnInit {
  @Input()
  items: RecordSwipperItem[];

  @Input()
  showActions = false;

  @Input()
  showSubheader = false;

  @Input()
  featured = false;

  @Input()
  swiperConfigType: SwiperConfigType;

  @Input()
  userSlider = false;

  @Input()
  selectedItemIndex: number;

  @Input()
  showSwiperButtons = true;

  @Input()
  useCardDisplay = false;

  @Output()
  indexClicked = new EventEmitter<number>();

  @ContentChild(SliderTitleDirective, { static: false })
  title!: SliderTitleDirective;

  @ContentChild(SliderSubheaderDirective, { static: false })
  subheader!: SliderSubheaderDirective;

  @ContentChild(SliderActionsDirective, { static: false })
  actions!: SliderActionsDirective;

  swiperConfig: SwiperOptions = undefined;

  constructor(private readonly configService: ConfigService) {}

  ngOnInit() {
    //this.setSwiperConfig();
    // Override config, think it's legacy config
    /**
     * The slidesOffsetAfter and slidesOffsetBefore property
     * is equal to the side padding of the carousel title
     * minus the inside padding of the item (8px)
     */
    const defaultBreakpoints = {
      0: { slidesPerView: 3.6, slidesPerGroup: 3 },
      768: { slidesPerView: 4.35, slidesPerGroup: 4 },
      1024: { slidesPerView: 6.35, slidesPerGroup: 6 },
      1200: { slidesPerView: 6.35, slidesPerGroup: 6 },
      1440: { slidesPerView: 7.5, slidesPerGroup: 7 },
      1800: { slidesPerView: 9.4, slidesPerGroup: 8 },
    };
    // This configuration is only used by the carousels in the lists/favs section.
    const featuredBreakpoints = {
      0: { slidesPerView: 3.6, slidesPerGroup: 3 },
      768: { slidesPerView: 4.35, slidesPerGroup: 4 },
      1024: { slidesPerView: 5, slidesPerGroup: 5 },
      1200: { slidesPerView: 5, slidesPerGroup: 5 },
      1440: { slidesPerView: 5.75, slidesPerGroup: 5.75 },
      1800: { slidesPerView: 6.35, slidesPerGroup: 6.35 },
    };

    const userBreakpoints = {
      0: { slidesPerView: 3.15, slidesPerGroup: 3.15 },
      768: { slidesPerView: 4.15, slidesPerGroup: 4.15 },
      1024: { slidesPerView: 6, slidesPerGroup: 6 },
    };

    const careerPlansBreakpoints = {
      0: { slidesPerView: 2.75, slidesPerGroup: 2.75 },
      768: { slidesPerView: 3.65, slidesPerGroup: 3.65 },
      1024: { slidesPerView: 6.75, slidesPerGroup: 6.75 },
    };

    const defaultOffset = 40;
    const userOffset = 8;
    const defaultSpaceBetween = 16;
    const careerPlansSpaceBetween = 8;

    let selectedOffset = defaultOffset;
    let selectedBp: SwiperOptions['breakpoints'] = defaultBreakpoints;
    let selectedSpaceBetween = defaultSpaceBetween;

    if (this.featured) {
      selectedBp = featuredBreakpoints;
    } else if (this.userSlider) {
      selectedBp = userBreakpoints;
      selectedOffset = userOffset;
    } else if (this.swiperConfigType === SwiperConfigType.CAREER_PLANS) {
      selectedBp = careerPlansBreakpoints;
      selectedOffset = userOffset;
      selectedSpaceBetween = careerPlansSpaceBetween;
    }

    this.swiperConfig = {
      spaceBetween: selectedSpaceBetween,
      breakpoints: selectedBp,
      slidesOffsetAfter: 8, //selectedOffset,
      slidesOffsetBefore: 8, //selectedOffset,
      navigation: {
        enabled: !this.configService.notDesktopDevice(),
      },
    };
  }

  private setSwiperConfig() {
    if (this.swiperConfigType == null) {
      this.setSwiperConfigFromBooleanFlags();
    } else {
      this.setSwiperConfigFromType();
    }
  }

  private setSwiperConfigFromBooleanFlags() {
    if (this.featured) {
      // this.swiperConfig = RecordSwipperUtils.FEATURED_CONFIG;
    }

    if (this.userSlider) {
      // this.swiperConfig = RecordSwipperUtils.USER_SLIDER_CONFIG;
    }
  }

  private setSwiperConfigFromType() {
    switch (this.swiperConfigType) {
      case SwiperConfigType.FEATURED:
        // this.swiperConfig = RecordSwipperUtils.FEATURED_CONFIG;
        break;
      case SwiperConfigType.CAREER_PLANS:
        // this.swiperConfig = RecordSwipperUtils.CAREER_PLAN_OPTIONAL_RESOURCES;
        break;
      default:
      // this.swiperConfig = RecordSwipperUtils.USER_SLIDER_CONFIG;
    }
  }

  onSwiperItemClicked(itemIndex: number) {
    this.indexClicked.emit(itemIndex);
  }
}
